// Required JS from node_modules
import introJs from "intro.js";
import React from "react";
import { createRoot } from "react-dom/client";

// Required JS from local files
import {
   Context,
   addInitialFunction,
   andJoinArray,
   dfmAlert,
   dfmConfirm,
   dfmDialog,
   dfmDialogCloseLast,
   editUserDetails,
   isDemoStudent,
   isParent,
   isTeacher,
   isTrustAdmin,
   mustUseSso,
   limitLength,
   parseJwtPayload,
   readFriendlyDate,
   redirectToRequiredLogin,
   timeSince,
} from "./dfm5";
import Subscription from "~/components/pages/settings/Subscription";
import { posthogEventAnonymiseModeTurnedOn } from "~/utils/posthog/misc";

// CSS
import "./settings.css";
import "intro.js/introjs.css";

/**
 * Configure and render Google SSO button
 * https://developers.google.com/identity/gsi/web/guides/display-button#javascript
 */
window.onload = function () {
   if (window.google) {
      google.accounts.id.initialize({
         client_id: window.DFL?.googleClientId || "NO-GOOGLE-CLIENT-ID-AVAILABLE",
         callback: useGoogleUser
      });
      google.accounts.id.renderButton(
         document.getElementById("tab-accountsettings-sso-buttons-google"),
         { theme: "outline", size: "large" }
      );
   }
}

$(document).ready(function(){

   $(".teacheronly").hide();
   $(".parentonly").hide();
   $(".demoonly").hide();

   $("#settings-menu-container").dfmSideMenu({
      panels: $("#settings-content"),
      onSelect: function(tab) {
         respondToSettingsTabSelection(tab);
      }
   });
   $("#settings-menu-container").dfmSideMenu("selectTab", "tabs-account");

   addInitialFunction(redirectToRequiredLogin);
   addInitialFunction(fillInAccountSettings);
   addInitialFunction(initialiseClassSelection);
   if(preloadState)addInitialFunction(function(){
      loadFromPageState(preloadState, false);
   });
   addInitialFunction(function(){
      // Demo students aren't real accounts, so can't be updated
      if (isDemoStudent()) {
         $(".demoonly").show();
         $("#accountsettings-tabs").hide();
         return;
      }

      // Show appropriate sections for the current user type
      if (isTeacher() || isTrustAdmin()) {
         $(".teacheronly").show();
      } else if (isParent()) {
         $(".parentonly").show();
      }
   });

   // Add interactivity, unless it's the demo student (in which case this is all hidden anyway)
   if (!isDemoStudent()) {
      $("#accountsettings-tabs").dfmTabs();
      $("#schoolsettings-tabs").dfmTabs();
      $("#accountsettings-update").click(updateAccountSettings);
      $("#tab-schoolsettings-update").click(updateSchoolSettings);

      $("#tab-accountsettings-piccontainer").click(function(){ selectProfilePic(true) });
      $("#tab-schoolsettings-piccontainer").click(function(){ selectProfilePic(false) });
      $(".office365-login").click(function(){
         window.location = '/azureconnect.php?action=link';
      });

      $("#accountsettings-passwordrow a").click(changePassword);
      $("#classes-viewclass-header .arrow-back").click(closeClass);

      $("#classes-viewclass-actions").actionMenu({
         default: "Apply action",
         options: [],
         highlightOnActive: true
      });
      $("#teachers-actions").actionMenu({
         default: "Apply action",
         options: [],
         highlightOnActive: true
      });
      $("#children-actions").actionMenu({
         default: "Apply action",
         options: [],
         highlightOnActive: true
      });

      $("#classes-viewclass-yeargroup").on("change", saveClassDetails);

      $("#classes-home-exportclass").click(function(){
         window.location = "/api/class/class/all?format=excel";
      });

      $("#classes-home-addclass").click(addClass);

      $("#classes-spreadsheetimport").click(spreadsheetImport);
      $("#classes-simsimport").click(function(){ checkSync("sims") });
      $("#classes-wondeimport").click(function(){ checkSync("wonde") });

      $("#classes-viewclass-main-header button").click(addUserToClass);
      $("#teachers-main-header button").click(addUserToClass);
      $("#children-main-header button").click(addUserToClass);
      $("#accountsettings-otheroptions-anonymise").click(turnOnAnonymise);
      $("#accountsettings-otheroptions-deleteaccount").click(deleteAccount);

      // Select all.
      $("#classes-students th input[type=checkbox]").click(function(){
         var isChecked = $(this).is(':checked');
         $("#classes-students tbody input[type=checkbox]").prop('checked', !isChecked);
         $("#classes-students tbody input[type=checkbox]").click();
      });
   }
});

function exportClassToExcel() {
   window.location = "/api/class/class/"+getCurrentClassId()+"?format=excel";
}

function loginAsClassDemoAccount() {
   $.ajax({
      url: "/api/class/loginasdemo/" + getCurrentClassId(),
      context: document.body,
      dataType: "json",
      type: "POST",
      success: function(data){
         window.location = 'dashboard.php';
      },
      error: function(jqXHR, textStatus, errorThrown){
         dfmAlert("There was an error logging on as this class' demo account:<br><br><strong>"+jqXHR.responseText+"</strong>");
      }
   });
}

function deleteAccount() {
   dfmAlert("We're working on this facility. For the moment, please email <a href='mailto:support@drfrost.org'>support@drfrost.org</a>. As per our Data Protection policy, we do not delete any student accounts that are in a school class.");
}

function deleteClass() {
   if(!getCurrentClassId())return;
   dfmConfirm(
      "Are you sure you want to delete the class <strong>"+$("#classes-viewclass-header-info h1").html()+"</strong>? This will simply unassign students from the class, but will <strong>not</strong> delete their accounts. Please note that the work you've assigned to students won't be deleted, but it makes it more difficult to view the data for the deleted class as a whole without recreating the class.",
      function() {
         var url = "/api/class/class/" + getCurrentClassId();
         console.log(url);
         $.ajax({
            url: url,
            type: "DELETE",
            contentType:false,
            processData: false,
            dataType: "json",
            cache: false,
            success: function(cid){
               $("#classes-classselection").studentSelector("reload", addSpecialClassesToList);
               closeClass();
            },
            error: function(j, textStatus, errorThrown) {
               dfmAlert("An error occurred when deleting the class: <strong>"+j.responseText+"</strong>");
            }
         });
      }
   );
}

function joinInfo() {
   var url = `https://${window.location.hostname}/join-class.php?cid=${getCurrentClassId()}&passcode=${$("#classes-viewclass").data("passcode")}`;
   dfmAlert(
      "<p>Give this URL to your students so that they can join your class.</p>"
      + "<p>New users will be asked to register, and will need to specify a email address.</p>"
      + "<p><a href='"+url+"'>"+url+"</a></p>");
}

function addClass() {
   dfmDialog("<p>This facility is to manually add a single class. If you wish to set up all your classes, use the <strong>Import by Spreadsheet</strong> option instead.<form>"
      +"<div><label>Name:</label><input type='text' id='classadd-name'></div>"
      +"<div><label>Yeargroup:</label><select id='classadd-yeargroup'></select></div>"
      +"<div><label>Assigned Teachers:</label><input type='hidden' id='classadd-teachers'></div>"
      +"<div><label>Course:</label><input type='hidden' id='classadd-courses'></div>",
       [{
          label: "Create", action: function () {
             var name = $("#classadd-name").val();
             var yeargroup = $("#classadd-yeargroup").val();
             var teachers = $("#classadd-teachers").val().split(",");
             var courses = $("#classadd-courses").val().split(",");
             if (!name) {
                dfmAlert("The name of the class was not entered");
                return false;
             }

             let data = {
                name: name,
                yeargroup: Number.parseInt(yeargroup)
             }

             if (teachers) {
                data["teachers"] = teachers;
             }
             if (courses) {
                data["courses"] = courses;
             }

             $.ajax({
                url: "/api/class/class",
                type: "POST",
                contentType: false,
                processData: false,
                dataType: "json",
                data: JSON.stringify(data),
                cache: false,
                success: function (cl) {
                   $("#classes-classselection").studentSelector("reload", addSpecialClassesToList);
                   console.log("[SuccessfullyCreatedClass] cl=" + JSON.stringify(cl));
                   loadClassData(cl.cid, addedClassMessage);
                },
                error: function (j, textStatus, errorThrown) {
                  const errorMessage = j.responseJSON?.message;
                  const alertMessage = {
                     "CLASS_LIMIT_REACHED":
                        "<p>We require schools to subscribe with us in order to have more than 3 classes.</p>"
                     +  "<p>Please ask the registered teacher at your school to go to the <a href='/settings.php?tab=subscription'>subscription page</a>.</p>"
                     +  "<p>If you have any further questions, please contact us at <a href='mailto:support@drfrost.org'>support@drfrost.org</a>.</p>"
                  }[errorMessage] || "An error occurred when creating the class: <strong>" + j.responseText + "</strong>"
                  dfmAlert(alertMessage);
                }
             });
          }}]);

   if (isParent()) {
      return;
   }

   $.ajax({
      url: "/api/school",
      type: "GET",
      contentType: false,
      processData: false,
      dataType: "json",
      cache: false,
      success: function (school) {
         var teachers = [];
         $.each(school._teachers, function (k, teacher) {
            teachers.push({val: teacher.uid, label: teacher.title + " " + teacher.firstname + " " + teacher.surname});
         });
         $("#classadd-teachers").dfmChoiceSelector({
            message: "Select the teacher(s) to associate with this class.",
            choices: teachers
         });
         var courses = [];
         $.each(school._courses, function (k, course) {
            courses.push({val: course.coid, label: course.name});
         });
         $("#classadd-courses").dfmChoiceSelector({
            message: "Select the course(s) to associate with this class. If you want to assign courses outside of your school (e.g. by exam boards) to your classes, find the course in the Course system, then select the option to use the course at your school.",
            choices: courses
         });

         $.each(school._yeargroupNaming, function (k, yeargroup) {
            $("#classadd-yeargroup").append("<option value='" + k + "'>" + yeargroup + "</option>");
         });
         $("#classadd-teachers").next().css('padding', '8px');
         $("#classadd-courses").next().css('padding', '8px');

      },
      error: function (j, textStatus, errorThrown) {
         dfmAlert("An error occurred when trying to get the school details: <strong>" + j.responseText + "</strong>");
      }
   });
}


function addedClassMessage() {

   setTimeout(function(){
      let steps = [];
      steps.push({
          element: "#classes-viewclass-main-header button",
          intro: "Use this button to add "+(Context.user.type!="parent" ? "students" : "your children")+" yourself. If you don't specify email addresses for "+(Context.user.accounttype!="parent" ? "students" : "your children")+", usernames and random passwords will be allocated for you.",
          position: 'right',
          highlightClass: 'menu-highlight'    });
      steps.push({
          element: "#classes-viewclass-options",
          intro: "If you don't want to list "+(Context.user.type!="parent" ? "students" : "your children")+" and want them to create their account themselves, look for the <strong>Join URL</strong> option in this dropdown.",
          position: 'right',
          highlightClass: 'menu-highlight'
       });
      steps.push({
          element: "#classes-viewclass-actions",
          intro: "When you select students in the table by clicking them, this menu will appear and give you options such as updating a user's password and details, or moving their class.",
          position: 'right',
          highlightClass: 'menu-highlight'
       });


      const intro = introJs();
      intro.setOptions({
       showStepNumbers: true,
       showBullets: false,
       exitOnOverlayClick: true,
       steps: steps,
      });
      intro.start();
   }, 1000);
}




function getSelectedStudents() {
   var students = [];
   var tableId = currentCid=="teachers" ? "#teachers-list" : (isParent() ? "#children-list" : "#classes-students");
   $(tableId+" tr.selected").each(function(i){
      students.push($(this).data("student"));
   });
   return students;
}

const ACTION_USER_EDIT = {label: "Edit Details", action: editStudentDetails };
const ACTION_USER_CHANGEPASSWORD = {label: "Change Password", action: changePasswordFromClassManage };
const ACTION_USER_MOVECLASS = {label: "Move Class", action: moveClass };
const ACTION_USER_REMOVEFROMCLASS = {label: "Remove From Class", action: removeUsersFromClass };
const ACTION_USER_DELETE = {label: "Delete", action: deleteStudents };
const ACTION_USER_ARCHIVE = {label: "Archive", action: archiveUsers };
const ACTION_USER_UNARCHIVE = {label: "Unarchive", action: archiveUsers };
const ACTION_USER_FORCEACTIVATION = {label: "Force Activation", action: forceActivation };

function reactToStudentSelection() {
   var ss = getSelectedStudents();
   var isTeachers = currentCid=="teachers";
   var actionsId = isTeachers ? "#teachers-actions" : (isParent() ? "#children-actions" : "#classes-viewclass-actions");
console.log("ACTIONSID: "+actionsId+" SSn="+ss.length);
   var options = [];
   if(ss.length==0) {
      $(actionsId).prop("disabled", true);
      return;
   }
   if(ss.length==1) {
      options.push(ACTION_USER_EDIT);
   }
   if(ss.length>=1) {
      if(!isTeachers && !isParent())options.push(ACTION_USER_MOVECLASS);
   }

   var allNonSSO = ss.every((student) => !(student.googlesso || student.office365 || student.fireflysso));

   if(allNonSSO)options.push(ACTION_USER_CHANGEPASSWORD);
   if(!isTeachers && currentCid!="archived" && currentCid!="classless" && !isParent())options.push(ACTION_USER_REMOVEFROMCLASS);
   options.push(ACTION_USER_DELETE);
   if(currentCid!="archived" && !isParent())options.push(ACTION_USER_ARCHIVE);
   else options.push(ACTION_USER_UNARCHIVE);

   var allNeedActivating = true;
   for(var i=0; i<ss.length; i++)if(ss[i].status!='0' || !ss[i].email)allNeedActivating = false;
   if(allNeedActivating && ss.length>0) {
      options.push(ACTION_USER_FORCEACTIVATION);
   }
   var wasDisabled = $(actionsId).is(":disabled");
   $(actionsId).prop('disabled', false);
   $(actionsId).actionMenu("setOptions", options);

}

function addUserToClass()
{
   var isTeachers = currentCid=="teachers";
   dfmDialog("<form>"
      +(isTeachers ? "" : "This facility is to manually add a single student. If you wish to set up all your classes, use the <strong>Import by Spreadsheet</strong> option instead.</p><p>If no email address is supplied, we'll generate a username for you.</p>")
      +(isTeachers ? "<div id='adduser-title-row'><label>Title</label><select id='adduser-title'><option>Mr</option><option>Ms</option><option>Miss</option><option>Mrs</option><option>Mx</option><option>M</option><option>Dr</option><option>Prof</option></select></div>" : "")
      +"<div><label>Firstname</label><input type='text' id='adduser-firstname'></div>"
      +"<div><label>Surname</label><input type='text' id='adduser-surname'></div>"
      +"<div><label>Email</label><input type='text' id='adduser-email' "+(isTeachers?"":" placeholder='(optional)'")+"></div>"
      +"</form>",
   [{label: "Submit", action: function(){

      var data = {};
      var title = $("#adduser-title").val();
      var firstname = $("#adduser-firstname").val();
      var surname = $("#adduser-surname").val();
      var email = $("#adduser-email").val();
      if(!firstname || !surname) {
         dfmAlert("Please ensure the firstname and surname are entered.");
         return false;
      }
      if(isTeachers && !email) {
         dfmAlert("For teacher accounts, an email address is required.");
         return false;
      }
      if(title)data.title = title;
      data.firstname = firstname;
      data.surname = surname;
      if(email)data.email = email;
      data.type = isTeachers ? "teacher" : "student";
      if(!isTeachers)data.cid = String(currentCid);

console.log("DATA: "+JSON.stringify(data));

      // If a teacher is being added, no need to search for people with matching names - just add immediately (checking for a duplicate!)
      if(isTeachers || isParent())addUserToClassFinal(data);
      else checkForMatchingStudents(data);

   }}]);

}

// This creates a new user.
function addUserToClassFinal(data) {
   data.sid = Context.user.sid; // just in case not set

   $.ajax({
      url: "/api/auth/register/manual",
      contentType:false,
      processData: false,
      cache: false,
      type: "POST",
      data: JSON.stringify(data),
      success: function({ user, password }){
         console.log("[SuccessfullyAddedUser]");
         const { firstname, surname, email } = user;
         loadClassData(getCurrentClassId());
         const passwordString = password ?
            `<p>Please provide ${firstname} with their details:</p><p><strong>Username:</strong> ${email}<br><strong>Password:</strong> ${password}</p>` :
            `<p>An email has been sent to ${email} for ${firstname} to activate their account and set their password.</p>`;
         dfmAlert(`<p>You have successfully created an account for ${firstname} ${surname}.</p>${passwordString}`);
      },
      error: function(jqXHR, textStatus, errorThrown) {
         var response = JSON.parse(jqXHR.responseText);
         if(response.message == "REQUIRE_SUBSCRIPTION") {
            dfmAlert("You require a subscription to add further teachers. Please use the 'Subscription' tab on the left.");
         }
         else dfmAlert("An error occurred trying to add the user: <strong>"+jqXHR.responseText+"</strong>");
      }
   });
}

function checkForMatchingStudents(data) {
   var url = "/api/users/studentmatches";

   $.ajax({
      url: url,
      contentType:false,
      processData: false,
      cache: false,
      type: "POST",
      dataType: "json",
      data: JSON.stringify(data),
      success: function(data2) {
         var matches = data2.students;
         if(matches.length==1 && data.email) {
            // There's an existing exact matching student, so add them to the class.
            var data3 = {}
            data3.uids = [matches[0].uid];
            data3.newcid = Number(getCurrentClassId());
            data3.moveoption = "add";
            moveClassFinal(data3);

         } else if(matches.length == 0) {
            // Definitely a new user, so create immediately. (We can reuse data)
            addUserToClassFinal(data);
         } else {
            // Need to present options to teacher.
            var optionsTxt = [];
            $.each(matches, function(k,match) {
               optionsTxt.push("<option value='"+match.uid+"'>"+match.surname+", "+match.firstname+" "+match.ctext+"</option>");
               dfmDialog("<h2>We've found "+(matches.length==1 ? "a potentially matching student." : "some potentially matching students.")+"</h2>"
                 +"<p>Either choose an existing student to add to this class, or choose to create as a new account.</p>"
                 +"<div><select id='adduser-selection'>"+optionsTxt.join("")+"<option value='new'>Add as a new user.</option></select></div>",
                   [{label: "Submit", action: function(){
                      var choice = $("#adduser-selection").val();
                      if(choice=="new") {
                         addUserToClassFinal(data);
                      } else {
                         var data3 = {}
                         data3.uids = [Number(choice)];
                         data3.newcid = Number(getCurrentClassId());
                         data3.moveoption = "add"; // leave them in old class.
                         moveClassFinal(data3);
                      }

                   }}]);
            });
         }
      },
      error: function(jqXHR, textStatus, errorThrown) {
         dfmAlert("An error occurred trying to add the user: <strong>"+jqXHR.responseText+"</strong>");
      }
   });

}

function moveClass() {
   var students = getSelectedStudents();
   var sNames = [];
   var sIds = [];
   $.each(students, function(k,v){
      sNames.push(v.firstname+" "+v.surname);
      sIds.push(v.uid);
   });
   var classesHTML = "<select name='moveclass'>";
   var allClasses = $("#classes-classselection").data('classes');
   $.each(allClasses, function(kC,vC) {
      if (!vC.cid) {
        classesHTML += "<option value='' disabled>-----------</option>";
      } else if (vC.cid !== getCurrentClassId()) {
        const escapedClassName = $("<div>").text(vC.name).html();
        classesHTML+= `<option value="${vC.cid}">${escapedClassName}</option>`;
      }
   });
   classesHTML+= "</select>";

   dfmDialog("<input type='radio' name='moveoption' value='move' id='moveoption-move' checked><label for='moveoption-move'>Move <strong>"+andJoinArray(sNames)+"</strong> to the following class:</label>"
         +(getCurrentClassId()!="classless" && getCurrentClassId()!="archived" ? "<br><input type='radio' name='moveoption' value='add' id='moveoption-add'><label for='moveoption-add'>Add <strong>"+andJoinArray(sNames)+"</strong> to the following class (but leave in "+$("#classes-viewclass-header-info h1").html()+"):</label>" : "")
         +"<br><br>"+classesHTML, [{label: "Continue", action: function(){

      var data = {}
      data.uids = sIds;
      data.newcid = Number($("select[name=moveclass").val());
      data.oldcid = Number(getCurrentClassId());
      data.moveoption = $("input[name=moveoption]:checked").val();
      moveClassFinal(data);
   }}]);

}

function moveClassFinal(data) {
   console.log(JSON.stringify(data));
   var url = "/api/class/move";
   $.ajax({
      url: url,
      contentType:false,
      processData: false,
      cache: false,
      type: "POST",
      data: JSON.stringify(data),
      success: function(data){
         $.modal.close();
         loadClassData(getCurrentClassId());
      },
      error: function(jqXHR, textStatus, errorThrown) {
         dfmAlert("An error occurred trying to move the class: <strong>"+jqXHR.responseText+"</strong>");
      }
   });

}

function removeUsersFromClass() {
   let cid = getCurrentClassId();
   let students = getSelectedStudents();
   let sNames = [];
   let studentIDs = [];

   $.each(students, function (k, v) {
      sNames.push(v.firstname + " " + v.surname);
      studentIDs.push(v.uid);
   });

   dfmConfirm(
       "Are you sure you want to remove <strong>" + andJoinArray(sNames) + "</strong> from the class <strong>" + $("#classes-viewclass-header-info h1").html() + "</strong>? This will simply unassign these students from the class, but will <strong>not</strong> delete their accounts nor affect any existing work you've set them.",
       function () {
          let data = {
             cid: cid,
             uids: studentIDs
          }

          $.ajax({
             url: "/api/class/removeusers",
             contentType: false,
             processData: false,
             type: "POST",
             data: JSON.stringify(data),
             cache: false,
             success: function (data) {
                $.modal.close();
                loadClassData(getCurrentClassId());
             },
             error: function (jqXHR, textStatus, errorThrown) {
                dfmAlert("An error occurred: <strong>" + jqXHR.responseText + "</strong>");
             }
          });
       });
}

function archiveUsers() {
   let cid = getCurrentClassId();
   let students = getSelectedStudents();
   let sNames = [];
   let sIds = [];

   let data = {
      cid: Number.parseInt(cid),
      uids: sIds,
   };

   $.each(students, function (k, v) {
      sNames.push(v.firstname + " " + v.surname);
      sIds.push(v.uid);
   });

   if (getCurrentClassId() === "archived") {
      data["reverse"] = true;

      $.ajax({
         url: "/api/class/archiveusers",
         contentType: false,
         type: "POST",
         processData: false,
         cache: false,
         data: JSON.stringify(data),
         success: function (data) {
            $.modal.close();
            dfmAlert("Your unarchived students are now in the 'CLASSLESS STUDENTS' class. You can select them and assign them to a class.");
            loadClassData("classless");
         },
         error: function (jqXHR, textStatus, errorThrown) {
            dfmAlert("An error occurred: <strong>" + jqXHR.responseText + "</strong>");
         }
      });
   } else {
      dfmConfirm(
          "Are you sure you want to archive <strong>" + andJoinArray(sNames) + "</strong>? Their accounts will be preserved but they will not appear in any search (e.g. when setting work). They will be moved to the 'Archive' tab on the left.",
          function () {
             data["reverse"] = false;

             $.ajax({
                url: "/api/class/archiveusers",
                contentType: false,
                type: "POST",
                processData: false,
                cache: false,
                data: JSON.stringify(data),
                success: function (data) {
                   $.modal.close();
                   loadClassData(getCurrentClassId());
                },
                error: function (jqXHR, textStatus, errorThrown) {
                   dfmAlert("An error occurred: <strong>" + jqXHR.responseText + "</strong>");
                }
             });
          });
   }
}

function forceActivation() {
   let students = getSelectedStudents();
   let uids = [];

   $.each(students, function (k, t) {
      if (t.status == 0) uids.push(t.uid)
   });

   let url = "/api/users/activate";
   let data = {uids: uids};

   $.ajax({
      url: url,
      contentType:false,
      type: "PATCH",
      processData: false,
      cache: false,
      data: JSON.stringify(data),
      success: function(data){
         $.modal.close();
         dfmAlert("You have successfully activated these accounts. The password for "+(students.length>1 ? "these" : "this")+" account"+(students.length>1 ? "s" : "")+" has been temporarily set to the word <strong>password</strong>. Students will be asked to change this password once they log in.");
         loadClassData(getCurrentClassId());
      },
      error: function(jqXHR, textStatus, errorThrown) {
         dfmAlert("An error occurred: <strong>"+jqXHR.responseText+"</strong>");
      }
   });
}

function editStudentDetails() {
   const student = getSelectedStudents()[0]; // edit details assumes only a selection of 1 user
   editUserDetails(student, () => loadClassData(getCurrentClassId()));
}

function deleteStudents() {
   let students = getSelectedStudents();
   let sNames = [];
   let sIds = [];

   $.each(students, function (k, v) {
      sNames.push(v.firstname + " " + v.surname);
      sIds.push(v.uid);
   });

   console.log("[DeleteStudents] " + JSON.stringify(sIds));

   let data = {
     uids: sIds
   };
   let message = "Are you sure you want to <strong>completely delete</strong> the account"+(sIds.length>1 ? "s" : "")+" of <strong>"+andJoinArray(sNames)+"</strong>? This will not just remove them from this class, but delete their account"+(sIds.length>1 ? "s" : "")+" entirely."

   dfmConfirm(
       message,
       function () {
          $.ajax({
             url: "/api/users",
             contentType: false,
             processData: false,
             type: "DELETE",
             cache: false,
             data: JSON.stringify(data),
             success: function (data) {
                $.modal.close();
                loadClassData(getCurrentClassId());
             },
             error: function (jqXHR, textStatus, errorThrown) {
                dfmAlert("An error occurred deleting these student(s): <strong>" + jqXHR.responseText + "</strong>");
             }
          });
       });
}

function changePasswordFromClassManage() {

   var students = getSelectedStudents();
   var uids = [];
   $.each(students, function(k,s){ uids.push(s.uid) });

   dfmDialog(
         "<p>Please communicate any changes of password to "+(students.length==1 ? "this student" : "these students")+" directly, as they will not be automatically informed of the change.</p>"
      +  "<form id='new-password-form'><label>New Password:</label><input type='password' name='password' autocomplete=new-password></form>",
      [
         {
            label: "Submit",
            action: function() {
               var password = $("input[name=password]").val();
               if($.trim(password)=="") {
                  dfmAlert("No password was provided.");
                  return false;
               }
               var data = {}
               data.password = $.trim(password);
               data.uids = uids;
               $.ajax({
                  url: "/api/users/passwords",
                  type: "PATCH",
                  contentType:false,
                  processData: false,
                  cache: false,
                  data: JSON.stringify(data),
                  success: function(){
                     $.modal.close();
                     dfmAlert("Password successfully updated.");
                     loadClassData(getCurrentClassId());
                  },
                  error: function(jqXHR) {
                     dfmAlert("An error occurred: <strong>"+jqXHR.responseText+"</strong>");
                  }
               });
            }
         }
      ]
   );

   $("#new-password-form").on("submit", (e) => {
      e.preventDefault();
      $(e.target).siblings(".dialog-buttons").find("button").trigger("click");
   })

}


function updateClassName() {
   dfmDialog("<form><label>Class Name:</label><input type='text' id='edit-classname'></form>", [{"label": "Update", action: function(){
      $("#classes-viewclass-header-info h1").html($("#edit-classname").val());
      saveClassDetails();
   }}]);
   $("#edit-classname").val($("#classes-viewclass-header-info h1").html()).focus();

}


function selectClass()
{
   var cid = JSON.parse($("#classes-classselection").val()).cids[0];
   loadClassData(cid);
}

function closeClass()
{
   $("#classes-viewclass").hide();
   $("#classes-home").show();
   $("#classes-classselection").studentSelector("reload", addSpecialClassesToList);
}

function getCurrentClassId() {
   return isParent() ? "children" : currentCid;
}

const PERSONAL = "***PERSONAL-ADDRESS***";
var currentCid = null;

function loadClassData(cid, listenerFunc, dontPreserveState) {
   var isTeachers = cid=="teachers";

   // Ensure we're on correct tab (but don't trigger tab selection listener)
   $("#settings-menu-container").dfmSideMenu("selectTab", isTeachers ? "tabs-teachers" : (isParent() ? "tabs-children" : "tabs-classes"), true);

   var tableId = isTeachers ? "#teachers-list" : (isParent() ? "#children-list" : "#classes-students");
   if(isParent()) {
      $("#tabs-children").show();
   }
   else if(!isTeachers && !isParent()) {
      $("#classes-viewclass").show();
      $("#classes-home").hide();
      $("#classes-viewclass-header-info h1").html("");
      $("#classes-viewclass-header-info h2").html("");
   }

   if(cid=="classless" || cid=="archived") {
      $(".classes-viewclass-header-item").hide();
   } else {
      $(".classes-viewclass-header-item").show();
   }

   $(tableId+" tbody").empty();

   let url = isTeachers ? "/api/class/teachers" : "/api/class/class/" + cid;

   $.ajax({
      url: url,
      type: "GET",
      context: document.body,
      dataType: "json",
      success: function(data){

         let classGrouping;
         if (isTeachers) {
            // Wrap data object so consistent with normal class view.
            classGrouping = {'_students' : data.teachers, name: 'Teachers', cid: 'teachers', passcode: ''};
         } else {
            classGrouping = data.classGrouping;
         }

         if (!dontPreserveState) {
            saveState("Class - " + classGrouping.name, "?cid=" + (isTeachers ? "teachers" : classGrouping.cid));
         }

         $("#classes-viewclass-header-info h1").html(classGrouping.name ? classGrouping.name : "[No name]");
         $("#classes-viewclass-header-info h2").html(classGrouping._students ? classGrouping._students.length+" students" : "0 students");
         $("#classes-viewclass").data("cid", classGrouping.cid);
         currentCid = classGrouping.cid;
         $("#classes-viewclass").data("passcode", classGrouping.passcode);
         $.each(classGrouping._students, function(k,student) {
            let loginType = "-";
            if(student.googlesso) {
               loginType = "<img src='images/google_icon.svg'>"
            } else if(student.fireflysso) {
               loginType = "<img src='homework/img/firefly-logo.png'>";
            } else if(student.office365) {
               loginType = "<img src='images/microsoft_icon.svg'>"
            } else {
               loginType = "Password"
            }

            var lastLogin = student.status==0 ? "Unactivated <span class='help-button'>?</span>" : (student.lastlogin ? timeSince(student.lastlogin) : "Never");

            $(tableId+" tbody").append("<tr id='classes-student-"+student.uid+"'>"
               +"<td class='classes-students-colcheckbox'><input type='checkbox'></td>"
               +"<td class='classes-students-colname'>"+student.surname+", "+student.firstname+"</td>"
               +(isParent() ? "" : "<td class='classes-students-colclasses'>"+student.ctext+"</td>")
               +"<td class='classes-students-colemail'>"+student.email+"</td>"
               +"<td class='classes-students-colpassword'>"+loginType+"</td>"
               +"<td class='classes-students-collastlogin'>"+lastLogin+"</td>"
               +"</tr>");
            $(`#classes-student-${student.uid} .help-button`).on("click", (e) => {
               e.stopPropagation();
               inactiveHelp();
            })
            $("#classes-student-"+student.uid).click(function(){
               if($(this).find('input[type=checkbox]').is(':checked')) {
                  $(this).find('input[type=checkbox]').prop('checked', false);
                  $(this).removeClass('selected');
               } else {
                  $(this).find('input[type=checkbox]').prop('checked', true);
                  $(this).addClass('selected');
               }
               reactToStudentSelection();
            });
            $("#classes-student-"+student.uid).data('student', student);
            $("#classes-student-"+student.uid+" input[type=checkbox]").click(function(e) {
               e.stopPropagation();
               // Repeated code, but whatever - it's being replaced anyway!
               if($(this).is(':checked')) {
                  $(this).closest('tr').addClass('selected');
               } else {
                  $(this).closest('tr').removeClass('selected');
               }
               reactToStudentSelection();
            });
         });

         // Disable parts of the UI if the class limit is being exceeded.
         // Also show a warning message to add context for disabled UI.
         const limitExceeded = data.limitExceeded;
         if (limitExceeded) {
            $("#classes-viewclass-limit-warning").show();
            $("#classes-viewclass-header-info h1").off("click");
            $("#classes-viewclass-header-info h1").css("cursor", "default");
            $("#classes-viewclass-yeargroup").attr("disabled", true)
            $("#classes-viewclass-main-header button").attr("disabled", true);
         } else {
            $("#classes-viewclass-limit-warning").hide();
            $("#classes-viewclass-header-info h1").on("click", updateClassName);
            $("#classes-viewclass-header-info h1").css("cursor", "pointer");
            $("#classes-viewclass-yeargroup").attr("disabled", false)
            $("#classes-viewclass-main-header button").attr("disabled", false);
         }
         $("#classes-viewclass-options").off("change");
         $("#classes-viewclass-options").actionMenu({
            default: "Class Options",
            options: [
               { label: "Delete Class", action: deleteClass },
               { label: "Get Join URL", action: joinInfo, disabled: limitExceeded },
               { label: "Class demo account", action: loginAsClassDemoAccount, disabled: limitExceeded },
               { label: "Export to Excel", action: exportClassToExcel, disabled: limitExceeded }
            ]
         });
         if (!isTeachers && !isParent()) {
            initialiseClassTeacherSelection(classGrouping, limitExceeded);
         }

         reactToStudentSelection();
         if(listenerFunc)listenerFunc();
         $(window).resize();

      },
      error: function(j, textStatus, errorThrown) {
         dfmAlert("An error occurred when trying to load the class data: <strong>"+j.responseText+"</strong>");
      }
   });

}

function initialiseClassTeacherSelection(cl, limitExceeded) {

   if(isParent())return;

   console.log("[GetAllTeachers]");
   $("#classes-viewclass-teachers").next().remove(); // get rid of any previous selector already there and just rebuild
   $("#classes-viewclass-courses").next().remove(); // get rid of any previous selector already there and just rebuild
   $("#classes-viewclass-yeargroup").empty();

   var teachersOfClass = [];
   $.each(cl._teachers, function(k, t) {
      teachersOfClass.push(t.uid);
   });
   $("#classes-viewclass-teachers").val(teachersOfClass.join(","));

   var coursesOfClass = [];
   $.each(cl._courses, function(k, c) {
      coursesOfClass.push(c.coid);
   });
   $("#classes-viewclass-courses").val(coursesOfClass.join(","));

   $.ajax({
      url: "/api/school",
      type: "GET",
      contentType:false,
      processData: false,
      dataType: "json",
      cache: false,
      success: function(school){
         var teachers = [];
         $.each(school._teachers, function(k,teacher) {
            teachers.push({val: teacher.uid, label: teacher.title+" "+teacher.firstname+" "+teacher.surname});
         });
         $("#classes-viewclass-teachers").dfmChoiceSelector({
            onChange: saveClassDetails,
            message: "Select the teacher(s) to associate with this class.",
            choices: teachers,
            disabled: limitExceeded
         });

         var courses = [];
         $.each(school._courses, function(k,course) {
            if(course.status==1 || course.status==3)courses.push({val: course.coid, label: course.name});
         });
         $("#classes-viewclass-courses").dfmChoiceSelector({
            onChange: saveClassDetails,
            message: "Select the course(s) to associate with this class. If you want to assign courses outside of your school (e.g. by exam boards) to your classes, find the course in the Course system, then select the option to use the course at your school.",
            choices: courses,
            disabled: limitExceeded
         });

         $.each(school._yeargroupNaming, function(k,yeargroup) {
            $("#classes-viewclass-yeargroup").append("<option value='"+k+"'>"+yeargroup+"</option>");
         });
         $("#classes-viewclass-yeargroup").val(cl.yeargroup);
      },
      error: function(j, textStatus, errorThrown) {
         dfmAlert("An error occurred when trying to get the school details: <strong>"+j.responseText+"</strong>");
      }
   });
}

function saveClassDetails() {
   let className = $("#classes-viewclass-header-info h1").html();
   let yeargroup = $("#classes-viewclass-yeargroup").val();
   let teachers = $("#classes-viewclass-teachers").val().split(",");
   let courses = $("#classes-viewclass-courses").val().split(",");
   let cid = $("#classes-viewclass").data("cid");

   let data = {
      name: className,
      yeargroup: Number.parseInt(yeargroup),
      teachers: teachers,
      courses: courses,
      cid: cid
   }

   $.ajax({
      url: "/api/class/class/" + cid,
      type: "PATCH",
      contentType:false,
      processData: false,
      cache: false,
      data: JSON.stringify(data),
      success: function(){
         console.log("[Successfully updated class]");
      },
      error: function(j) {
         const errorMessage = j.responseJSON?.message;
         const alertMessage = {
            "CLASS_LIMIT_REACHED":
               "<p>In order to edit this class, please subscribe or reduce your total number of classes to 3 or fewer.</p>"
            +  "<p>If you have any further questions, please contact us at <a href='mailto:support@drfrost.org'>support@drfrost.org</a>.</p>"
         }[errorMessage] || "An error occurred when updating the class: <strong>" + j.responseText + "</strong>"
         dfmAlert(alertMessage);

         // Need to call loadClassData to revert the state of various input elements that have saveClassDetails as a callback.
         // This does more than required but it's *much* less fiddly than handling each element case by case.
         loadClassData(cid);
      }
   });
}

function inactiveHelp() {
   dfmAlert("<p>This account is currently unactivated. If the email is supplied for this account, the user should have received an automated email with an activation link.</p>"
     +"<p>If this was not received/deleted, you can use <strong>Force Activation</strong> from the Apply Actions dropdown to manually activate it.</p>"
     +"<p><strong>If no email address was supplied</strong>, you need to give the student the registration URL within the class information.</p>");
}



function initialiseClassSelection() {
   if(!isTeacher() && Context?.user?.type !== "trust") return;
   $("#classes-classselection").studentSelector({classesOnly: true, onChange: selectClass, onLoad: addSpecialClassesToList});
}

function addSpecialClassesToList() {
   $("#classes-classselection").next().find('.dfm_studentSelector_classdropdown').append("<option value='archived'>ARCHIVED STUDENTS</option><option value='classless'>CLASSLESS STUDENTS</option>");
}

function respondToSettingsTabSelection(tab) {
   if(tab=="tabs-auditlog") {
      var url = "/api/school/audit";
      console.log(url);
      $.ajax({
         url: url,
         type: "GET",
         context: document.body,
         dataType: "json",
         success: function(data, textStatus, jqXHR){
            $("#tabs-auditlog tbody").empty();
            $.each(data, function(k,item) {
               $("#tabs-auditlog tbody").append("<tr><td>"+item._name+"</td><td>"+item.action+"</td><td title='" + item.data + "'>"+(item.data.length>100 ? item.data.substr(0,100)+"..." : item.data)+"</td><td>"+readFriendlyDate(item.d, true)+"</td></tr>");
            });
         },
         error: function(j, textStatus, errorThrown) {
            dfmAlert("An error occurred when trying to get the audit log: <strong>"+j.responseText+"</strong>");
         }

      });

   } else if(tab=="tabs-subscription") {
      renderSubscriptionPanel();
   } else if(tab=="tabs-schoolsettings") {
      fillInSchoolSettings();
   } else if(tab=="tabs-teachers") {
      loadClassData("teachers");
   } else if(tab=="tabs-children") {
      loadClassData("children");
   } else if (tab === "tabs-classes") {
      closeClass();
   }
}

function changePassword() {
   var dialogHTML = "";
   dialogHTML+= "<form>";
   dialogHTML+= "<div><label>New password:</label><input type='password' id='newpassword'></div>";
   dialogHTML+= "<div><label>Confirm password:</label><input type='password' id='confirmpassword'></div>";
   dialogHTML+= "</form>";
   dfmDialog(dialogHTML, [{label: "Submit", action: function(){
      var p1 = $("#newpassword").val();
      var p2 = $("#confirmpassword").val();
      if (!p1 && !p2) {
         dfmAlert("Please enter a new password.");
      } else if(p1 !== p2) {
         dfmAlert("The passwords do not match.");
      } else {
         $("#accountsettings-password").val(p1);
         updateAccountSettings();
         $.modal.close();
      }
   }}]);

}

// Use the current Context.user object to fill in the form with the account settings.
function fillInAccountSettings() {
   if (Context?.user) {
      console.log("[FillInAccountSettings]");
      if(isTeacher() || isTrustAdmin()) {
         $("#accountsettings-title").val(Context.user.title);
      } else {
         $("#accountsettings-titlerow").hide();
         $("#accountsettings-newsletterrow").hide();
         $("#accountsettings-firstname").hide();
         $("#accountsettings-fixed-firstname").show().html(Context.user.firstname);
         $("#accountsettings-surname").hide();
         $("#accountsettings-fixed-surname").show().html(Context.user.surname);
         $("#accountsettings-update").hide();

      }
      $("#accountsettings-fixed-email").html(Context.user.email);
      $("#accountsettings-firstname").val(Context.user.firstname);
      $("#accountsettings-surname").val(Context.user.surname);
      $("#accountsettings-newsletter").val(Context.user.unsubscribed);
      if(Context.user.googlesso || Context.user.office365 || Context.user.fireflysso) {
         $("#accountsettings-passwordrow").hide();
         $("#tab-accountsettings-sso-buttons").hide();
         $("#tab-accountsettings-sso h2").show();
         if(Context.user.googlesso)$("#tab-accountsettings-sso h2 span").html("a Google");
         if(Context.user.office365)$("#tab-accountsettings-sso h2 span").html("an Office365");
         if(Context.user.fireflysso)$("#tab-accountsettings-sso h2 span").html("a Firefly");
      }
      $("#tab-accountsettings-unlink").click(unlinkFromSSO);
      if (mustUseSso()) {
         $("#tab-accountsettings-unlink").hide();
      }

      if(!Context.user.pic)$("#tab-accountsettings-piccontainer").html("");
      else $("#tab-accountsettings-piccontainer").html("<img src=\""+Context.user.pic+"?v="+Math.random()+"\">");
   }
}

// Save the account form data to the database.
function updateAccountSettings() {
   let data = {
      firstname: $("#accountsettings-firstname").val(),
      surname: $("#accountsettings-surname").val(),
   }
   if (isTeacher()) {
      data["title"] = $("#accountsettings-title").val();
      data["unsubscribed"] = $("#accountsettings-newsletter").val();
   }
   if ($("#accountsettings-password").val()) {
      data["password"] = $("#accountsettings-password").val();
   }

   $.ajax({
      url: "/api/user/other",
      type: "PATCH",
      contentType: false,
      processData: false,
      cache: false,
      data: JSON.stringify(data),
      success: function (data) {
         dfmAlert("Account details successfully updated.");
      },
      error: function (j, textStatus, errorThrown) {
         dfmAlert("An error occurred when trying to update your account: <strong>" + j.responseText + "</strong>");
      }
   });
}

function updateSchoolSettings() {
   const primaryContactIdSelection = parseInt($("#tab-schoolsettings-primarycontact select").val());
   const primaryContactId = primaryContactIdSelection ? primaryContactIdSelection : null;
   let data = {
      domain: $("#tab-schoolsettings-domain input").val(),
      optout: Number.parseInt($("#optout").val()),
      primaryContactId,
      ynames: $("#tab-schoolsettings-yeargroupnaming select").val(),
   }
   $.ajax({
      url: "/api/school",
      type: "PATCH",
      contentType:false,
      processData: false,
      cache: false,
      data: JSON.stringify(data),
      success: function(){
         dfmAlert("School settings successfully updated.");
      },
      error: function(j) {
         dfmAlert("An error occurred when trying to update your school settings: <strong>"+j.responseText+"</strong>");
      }
   });
   return false;
}

// Use the current Context.user object to fill in the form with the account settings.
function fillInSchoolSettings() {
   console.log("[FillInSchoolSettings]");

   $.ajax({
      url: "/api/school",
      type: "GET",
      contentType: false,
      processData: false,
      dataType: "json",
      cache: false,
      success: function (school) {
         $("#tabs-schoolsettings").data('school', school);
         console.log(JSON.stringify(school));
         $("#tab-schoolsettings-name span").html(school.name);
         $("#tab-schoolsettings-town span").html(school.town);
         $("#tab-schoolsettings-country span").html(school.country);
         $("#tab-schoolsettings-postcode span").html(school.postcode);
         $("#tab-schoolsettings-timezone span").html(school.timezone);
         $("#tab-schoolsettings-minage span").html(school.minage);
         $("#tab-schoolsettings-maxage span").html(school.maxage);
         $("#tab-schoolsettings-phase span").html(school.phase);
         $("#tab-schoolsettings-domain input").val(school.domain);
         $("#tab-schoolsettings-optout select").val(school.leaderboardoptout);
         if (school.pic) {
            $("#tab-schoolsettings-piccontainer").html("<img src=\"" + school.pic + "\">");
         }
         if ($("#tab-schoolsettings-yeargroupnaming select").children().length == 0) {
            loadYeargroupNamingSchemes(school.ynames);
         }
         buildPrimaryContactSelect(school.primarycontactid, school._teachers);

      },
      error: function (j, textStatus, errorThrown) {
         dfmAlert("An error occurred when trying to get the school details: <strong>" + j.responseText + "</strong>");
      }
   });
}

function unlinkFromSSO() {
   $.ajax({
      url: "/api/user/current/unlink_from_sso",
      type: "PATCH",
      contentType: false,
      processData: false,
      cache: false,
      success: function (data) {
         $("#accountsettings-passwordrow").show();
         $("#tab-accountsettings-sso-buttons").show();
         $("#tab-accountsettings-sso h2").hide();

      },
      error: function (j, textStatus, errorThrown) {
         dfmAlert("An error occurred when trying to unlink from Google/Office365/Firefly: <strong>" + j.responseText + "</strong>");
      }
   });
}

// isProfilePic = false indicates the school logo.
function selectProfilePic(isProfilePic) {
   dfmAlert(`
      <div style='display: flex; flex-direction: column; gap: 12px;'>
         <b>Upload picture</b>
         <input type='file' name='file' id='profilepic-file'>
      </div>
      <div id='remove-image' style='border-top: 1px black solid; display: none; margin-top: 20px; padding-top: 20px;'>
         <button style='padding: 8px 12px;'>Remove profile picture</button>
      </div>
   `);
   $("#profilepic-file").on("change", function(e){
      var files = e.target.files;
      uploadProfilePic(files, isProfilePic);
      $.modal.close();
   });
   if (isProfilePic && Context.user?.pic) {
      $("#remove-image").show();
      $("#remove-image > button").off("click");
      $("#remove-image > button").on("click", handleDeleteProfilePic);
   } else {
      $("#remove-image").hide();
   }
}

function handleDeleteProfilePic() {
   $.ajax({
      url: "/api/user/current/profile_pic",
      type: "DELETE",
      contentType: false,
      processData: false,
      cache: false,
      dataType: "json",
      success: function (data) {
         $("#tab-accountsettings-piccontainer").html("");
         Context.user.pic = undefined;
         Context.user.thumb = undefined;
         $.modal.close();
      },
      error: function (j, textStatus, errorThrown) {
         dfmAlert("There was an error: " + j.responseText + " " + errorThrown);
      }
   });
}

function uploadProfilePic(files, isProfilePic) {
   let formData = new FormData();
   formData.append('file', files[0]);

   $.ajax({
      url: isProfilePic ? "/api/user/current/profile_pic" : "/api/uploadschoolpic",
      type: "POST",
      contentType: false,
      processData: false,
      dataType: "json",
      cache: false,
      data: formData,
      success: function (data) {
         console.log(JSON.stringify(data));
         var elem = isProfilePic ? $("#tab-accountsettings-piccontainer") : $("#tab-schoolsettings-piccontainer");
         elem.html("<img src=\"" + data.pic + "?v=" + Math.random() + "\">");
         Context.user.pic = data.pic;
         Context.user.thumb = data.thumb;
      },
      error: function (j, textStatus, errorThrown) {
         dfmAlert("There was an error: " + j.responseText + " " + errorThrown);
      }
   });
}

function useGoogleUser(response) {
   const token = response.credential;

   // Note: this is silly, we should just pass the token to the backend and let it make all the relevant changes
   //       instead of needing to parse it ourselves here
   const payload = parseJwtPayload(token);
   Context.user.firstname = payload['given_name'];
   Context.user.surname = payload['family_name'];
   Context.user.email = payload['email'];
   Context.user.googlesso = "-"; // The actual value is calculated in the controller using the id_token.

   let data = {
      firstname: Context.user.firstname,
      surname: Context.user.surname,
      email: Context.user.email,
      googletoken: token
   };

   $.ajax({
      url: "/api/user/other",
      type: "PATCH",
      contentType: false,
      processData: false,
      cache: false,
      data: JSON.stringify(data),
      success: function (data) {
         fillInAccountSettings();
      },
      error: function (j, textStatus, errorThrown) {
         dfmAlert("An error occurred when trying to update your account: <strong>" + j.responseText + "</strong>");
      }
   });
}

// ------------------------------------------
// MIS integration + spreadsheet import
// ------------------------------------------

function spreadsheetImport() {

   dfmDialog("<h1>Import by Spreadsheet</h1>"
              +"<p>Student accounts which are already active will be unaffected, except that the class groupings will be changed.</p>"
              +"<p>You must first <a href='/docs/DrFrost-Import.xlsx'>download this spreadsheet file</a> and use it to fill in your class lists. Then upload this file using the form below.</p>"
              +"<form style='background-color:#F7F8FA;padding:20px' enctype='multipart/form-data'>"
              +"  <div>"
              +"    <label style='width:100px'>Import File:</label>"
              +"    <input id='import-file' name='import-file' type='file'>"
              +"  </div>"
              +"  <div style='margin-top:20px'>"
              +"    <label for='import-mode' style='width:100px'>Mode:</label>"
              +"    <span style='display:inline-block'>"
              +"      <input type='radio' name='import-mode' value='all' id='import-all'>"
              +"      <label for='import-all' class='rlabel' style='width:250px'>My spreadsheet contains <strong>all</strong> students in my school. All existing class groupings will be removed."
              +"            <strong><u>WARNING: Do not use this option to add individual classes, but to set up all your school's classes. This will wipe all existing class lists for the whole school.</u></strong>"
              +"      </label><br><br>"
              +"      <input type='radio' name='import-mode' value='partial' id='import-partial'>"
              +"      <label for='import-partial' class='rlabel' style='width:250px'>My spreadsheet only contains <strong>new</strong> classes I want to add <strong>or</strong> students I want to add to existing classes. Leave all other existing accounts/classes alone.</label>"
              +"    </span>"
              +"  </div>"
              +"</form>",
     [  { label: "Execute",
          action: function(){
             if($("input[name=import-mode]:checked").val()=="all")dfmConfirm("<h1>Are you absolutely sure you want to do this?</h1><p>Remember, <u><strong>this will delete all existing class groupings at your school</strong></u> (although accounts are preserved). We <strong>highly recommend you press the Preview button first</strong>. We also recommend backing up any current class groupings by using the <strong>Export to Excel</strong> button; the spreadsheet it outputs can be used for this import wizard.</p>",
                function(){ return executeSpreadsheetImport(0); });
             else executeSpreadsheetImport(0);
             return false;
          }
        },
        { label: "Preview",
          action: function(){
             return executeSpreadsheetImport(1);
          }
        }
     ]);

}

function executeSpreadsheetImport(preview)
{
   var formData = new FormData();
   if(!$("input[name=import-file]").val()) {
      $.modal.close();
      dfmAlert("No file was selected");
      return false;
   }
   var importMode = $("input[name=import-mode]:checked").val();
   if (!importMode) {
      $.modal.close();
      dfmAlert("No import mode was selected");
      return false;
   }
   var file = $("input[name=import-file]").prop('files')[0];

   formData.append('import-file', $("input[name=import-file]").prop('files')[0]);
   formData.append('preview', preview);
   formData.append('sid', Context.user.sid);
   formData.append('import-mode', $("input[name=import-mode]:checked").val());
   $.modal.close();
   var url = "/api/mis/spreadsheet/"+Context.user.sid+"/"+importMode+(preview ? "?preview=1" : "");
   dfmAlert("<div id='spreadsheet-upload-modal'>Processing...</div>");
   const spreadsheetUploadModal = $("#spreadsheet-upload-modal");
   $.ajax({
      url: url,
      type: "POST",
      contentType: false,
      processData: false,
      dataType: "json",
      cache: false,
      data: formData,
      success: function(data){
         if(preview === 1) {
            spreadsheetUploadModal.html("<div style='width:800px;height:500px;overflow-y:scroll'>"+data.html+"</div>");
            $(".modal").css('max-width','850px');
         } else {
            $("#classes-classselection").studentSelector("reload", addSpecialClassesToList);
            spreadsheetUploadModal.html("Import successfully completed. You can now view each class to assign teachers and courses.<br><br>If your import included email addresses, your students should now be receiving automated emails to activate their accounts and set a password/link with Google or Microsoft.<br><br>If you created accounts without email addresses, then after selecting the class, we recommend exporting your class, using Class Options &rarr; Export to Excel, which will include all the passwords we have generated for them. Passwords for accounts <em>with</em> email addresses will not be visible.");

         }
      },
      error: function(j, textStatus, errorThrown) {
         const errorMessage = j.responseJSON?.message;
         const alertMessage = {
            "CLASS_LIMIT_REACHED":
               "<p>We require schools to subscribe with us in order to have more than 3 classes.</p>"
            +  "<p>In order to use the spreadsheet import tool, please subscribe or reduce your total number of classes in your import.</p>"
            +  "<p>If you have any further questions, please contact us at <a href='mailto:support@drfrost.org'>support@drfrost.org</a>.</p>"
         }[errorMessage] || "There was an error executing this spreadsheet import: " + j.responseText + " " + errorThrown;
         spreadsheetUploadModal.html(alertMessage);
      }
   });
}

function misStartSyncProcess(isPreview, source) {
      $(this).val("Please wait...").prop('disabled', true);

      // dfmDialogCloseLast();
      let data = {};
      data.sid = Context.user.sid;
      if(source=="bromcom") {
         data.schoolID = $("input[name=schoolID]").val();
         data.username = $("input[name=username]").val();
         data.effectivedate = $("input[name=effectivedate]").val();
         data.password = $("input[name=password]").val();
         data.customserver = $("input[name=customserver]").val();
      }
      data.preview = isPreview;
      data.source = source;

      var url = "/api/mis/getsubjectlist";
      console.log(url);
      console.log(JSON.stringify(data));

      $.ajax({
         url: url,
         type: "POST",
         contentType:false,
         processData: false,
         dataType: "json",
         cache: false,
         data: JSON.stringify(data),
         success: function(response, textStatus, jqXHR){
            misListSubjects(response, data);
         },
         error: function(jqXHR, textStatus, errorThrown){
            var message = JSON.parse(jqXHR.responseText).message;
            if(message=="PAID_SUBSCRIPTION_REQUIRED") {
               dfmAlert("This type of syncing is only available for schools with paid subscriptions, as it directly costs Dr Frost Learning a fee per school.<br><br>Go to the Subscription tab to review your subscription.");
            } else if(message=="WONDE_SCHOOL_NOT_APPROVED") {
               dfmConfirm("Your school is on Wonde but you need to give Wonde permission for Dr Frost Learning to use your school class data.<br><br><strong>Do you consent to Dr. Frost accessing your school data via Wonde?</strong>", requestWondeAccess);
            } else if(message=="WONDE_SCHOOL_NOT_FOUND") {
               dfmAlert("We can't find your school on Wonde. Please email <a href='mailto:support@drfrost.org'>support@drfrost.org</a> for further assistance.");
            } else if(message=="WONDE_SCHOOL_NOT_YET_AUDITED") {
               dfmAlert("You've submitted a request to Wonde to allow Dr Frost to access your school data, but Wonde is still in the process of authorising this.<br><br>Please either contact Wonde support or <a href='mailto:support@drfrost.org'>support@drfrost.org</a>.");
            } else {
               dfmAlert("There was an error getting the subject list:<br><br><strong>"+jqXHR.responseText+"</strong>");
            }
         }
      });

      return false;

}

function requestWondeAccess() {
   $.ajax({
      url: "/api/mis/requestwondeaccess",
      type: "POST",
      contentType:false,
      processData: false,
      dataType: "json",
      cache: false,
      success: function(response, textStatus, jqXHR){
         dfmAlert("We've requested access from Wonde. You'll now either receive and email from Wonde Support or you'll need to go to your Wonde dashboard to approve our request.");
      },
      error: function(jqXHR, textStatus, errorThrown){
         dfmAlert("There was an error contacting Wonde:<br><br><strong>"+jqXHR.responseText+"</strong>");
      }
   });
}

function misListSubjects(subjects, data)
{
   var isPreview = data.preview;
   dfmDialogCloseLast();
   var dialogHTML = "<h2>Choose the subjects for your "+(isPreview ? "preview" : "import")+"</h2>"
   dialogHTML+= "<p>We'll then give you a selection of classes for these subjects to do the import.</p>";
   dialogHTML+= "<ul id='mis-subjects' style='max-height:300px;overflow-y:scroll;list-style:none;padding:0'>";
   $.each(subjects, function(k, subject) {
      dialogHTML+= "<li><label><input type='checkbox' value=\""+subject.id+"\">"+subject.name+"</label></li>";
   });
   dialogHTML+= "</ul>";
   dfmDialog(dialogHTML, [{label: "Continue", action: function(){
      var subjects = [];
      $("#mis-subjects input[type=checkbox]:checked").each(function(){
         subjects.push($(this).val());
      });
      data.subjects = subjects;
      var url = "/api/mis/getclasslist";
      console.log(url);
      console.log(JSON.stringify(data));
      $.ajax({
         url: url,
         type: "POST",
         contentType:false,
         processData: false,
         dataType: "json",
         cache: false,
         data: JSON.stringify(data),
         success: function(classes, textStatus, jqXHR){
            misListClasses(classes, data);
         },
         error: function(j, textStatus, errorThrown){
            dfmAlert("There was an error getting the MIS class list:<br><br><strong>"+j.responseText+"</strong>");
         }
      });

   }}]);
   return false;
}


function checkSync(source)
{
   var url = "/api/mis/syncdetails";
   $.ajax({
      url: url,
      type: "GET",
      contentType:false,
      processData: false,
      dataType: "json",
      cache: false,
      success: function(data){
         checkSyncWithDetails(data, source);
      },
      error: function(j, textStatus, errorThrown) {
         dfmAlert("There was an error getting the MIS sync details: "+j.responseText);
      }
   });
}

function checkSyncWithDetails(data, sourceBeingChecked) {
   if(data && data.source == "bromcom" && sourceBeingChecked != "bromcom") {
      dfmAlert("You are currently synced with Bromcom. Open the Bromcom syncing and click the <strong>Stop Syncing</strong> button.");
   } else if(data && data.source == "wonde" && sourceBeingChecked != "wonde") {
      dfmAlert("You are currently synced with Wonde. Open the Wonde syncing and click the <strong>Stop Syncing</strong> button.");
   } else if(data && data.source == "sims" && sourceBeingChecked == "sims") {
      dfmDialog("You are currently synced with your school's SIMS database.", [{label: "Stop Syncing", action: function(){
         removeSyncing();
      }}]);
   } else if(data && data.source == "wonde" && sourceBeingChecked == "wonde") {
      dfmDialog("You are currently synced with Wonde.", [{label: "Stop Syncing", action: function(){
         removeSyncing();
      }}]);
   } else if(!data && sourceBeingChecked == "sims") {
      dfmDialog("We're just about to check whether your school is set up for SIMS. Choose one of the options below."
       + "<h2 style='margin-top:5px;font-size:13px;font-weight:100'>Please note that a DrFrostMaths subscription is required to synchronise with MIS systems.</h2>",
        [
           {label: "Sync",
            action: function(){
                       simsGetClassList(0);
                    }
           },
           {label: "Preview",
            action: function(){
                       simsGetClassList(1);
                    }
           }
        ]
     );
   } else if(!data && sourceBeingChecked == "wonde") {
      dfmDialog("<p style='background:#fde68a;padding:8px 10px;font-size:13px;'><strong>Warning:</strong> If your school has <strong>changed MIS</strong> since last using Wonde please contact <strong>support@drfrost.org</strong> before attempting to synchronise.</p>"
       + "<p>We're just about to check whether your school is set up for Wonde. Choose one of the options below.</p>"
       + "<p style='font-size:13px;'>Please note that a DrFrostMaths subscription is required to synchronise with MIS systems.</p>",
        [
           {label: "Sync",
            action: function(){
                       misStartSyncProcess(false, "wonde")
                    }
           },
           {label: "Preview",
            action: function(){
                       misStartSyncProcess(true, "wonde")
                    }
           }
        ]
     );

   } else {
      console.log(JSON.stringify(data));
   }
}

function removeSyncing() {
   $.ajax({
      url: "/api/mis/removesyncing",
      type: "DELETE",
      contentType: false,
      processData: false,
      dataType: "json",
      cache: false,
      success: function (data, textStatus, jqXHR) {
         dfmAlert("You are no longer synced to an external MIS database.");
      },
      error: function (jqXHR, textStatus, errorThrown) {
         dfmAlert("There was an error removing MIS syncing:<br><br><strong>" + jqXHR.responseText + "</strong>");
      }
   });
}

function simsGetClassList(isPreview) {

   var data = {preview: isPreview, source: "sims", sid: Context.user.sid}

   // Note that SIMS doesn't have a subject list. So go straight to class list.
   dfmAlert("Loading...");
   $.ajax({
      url: "/api/mis/getclasslist",
      type: "POST",
      contentType:false,
      processData: false,
      dataType: "json",
      cache: false,
      data: JSON.stringify(data),
      success: function(classes, textStatus, jqXHR){
         $.modal.close();
         misListClasses(classes, data);
      },
      error: function(jqXHR, textStatus, errorThrown){
         $.modal.close();
         if(jqXHR.responseText=="SIMS_UNAUTHORISED") {
            dfmAlert("<p>It seems your school hasn't given us authorisation to use your class list data.</p>"
             +"<p>In order to connect with SIMS, your school data/IT manager needs to log in to <a href='https://id.sims.co.uk'>id.sims.co.uk</a> and add two 'tiles': the <strong>Dr Frost Learning</strong> tile and <strong>Link SIMS to ID</strong> tile.</p>"
             +"<p>Please direct them to <a href='https://docs.google.com/document/d/17m_0FrASzcCII74w1hGLbKoZ57JnvtJY5tbrIq4nIfk/edit?usp=sharing'>this document</a> for more SIMS setup information.<p>"
             +"<p>Please note we are still testing this new facility. Please contact <a href='mailto:support@drfrost.org'>support@drfrost.org</a> for further enquiries.</p>");
         }
         else dfmAlert("There was an error getting the MIS class list:<br><br><strong>"+jqXHR.responseText+"</strong>");
      }
   });

}


function misListClasses(classes, data)
{
   var isPreview = data.preview;
   dfmDialogCloseLast();
   var dialogHTML = "<h2 style='margin-bottom:0px'>Choose the classes to finish your "+(isPreview ? "preview" : "import")+"</h2>"
   dialogHTML+= "<h3 style='margin-top:5px;font-size:13px;font-weight:100'>Source: "+(data.source=="bromcom" ? "Bromcom" : (data.source=="sims" ? "SIMS" : "Wonde"))+"</h3>";
   dialogHTML+= "<div><label style='font-weight:700'><input type='checkbox' id='mis-class-selectall'> Select All</label></div>";
   dialogHTML+= "<ul id='mis-classes' style='max-height:300px;overflow-y:scroll;list-style:none;padding:0'>";
   $.each(classes, function(k, c) {
      dialogHTML+= "<li><label><input type='checkbox' value=\""+c.misid+"\">"+c.name+"</label></li>";
   });
   dialogHTML+= "</ul>";
   dfmDialog(dialogHTML, [{label: isPreview ? "Generate Preview" : "Finish Sync", action: function(){
      var classesSelected = [];
      $("#mis-classes input[type=checkbox]:checked").each(function(){
         classesSelected.push($(this).val());
      });
      data.classes = classesSelected;
      finishSyncing(data);
   }}]);
   $("#mis-class-selectall").change(function(){
      var isChecked = $(this).is(":checked");
      $("#mis-classes input[type=checkbox]").prop('checked', isChecked);
   });

}

function finishSyncing(data) {
   var url = "/api/mis/finishsyncing";
   console.log(url);
   console.log(JSON.stringify(data));
   dfmAlert("Reading data from external MIS database. This may take a while...");
   $.ajax({
      url: url,
      type: "POST",
      contentType:false,
      processData: false,
      dataType: "json",
      cache: false,
      data: JSON.stringify(data),
      success: function(response, textStatus, jqXHR){
         $.modal.close();
         console.log(JSON.stringify(response));
         if(response.preview)
         {
            dfmAlert("<div style='max-height:500px;overflow-y:scroll'>"+response.preview+"</div>");
            $(".modal").css('max-width','750px');
         }

         else if(response.completed)
         {
            $("#classes-classselection").studentSelector("reload", addSpecialClassesToList);
            dfmAlert("<h2>All done!</h2>");
         }
      },
      error: function(jqXHR, textStatus, errorThrown){
         dfmAlert("There was an error finalising the MIS sync:<br><br><strong>"+jqXHR.responseText+"</strong>");
      }
   });
}

function turnOnAnonymise() {
   $.ajax({
      url: "/api/user/current/toggleanonymous",
      contentType: false,
      processData: false,
      cache: false,
      type: "GET",
      success: function ({ anonymiseTurnedOn }) {
         if (anonymiseTurnedOn) {
            posthogEventAnonymiseModeTurnedOn();
         }

         window.location = 'dashboard.php';
      },
      error: function (jqXHR, textStatus, errorThrown) {
         dfmAlert("An error occurred trying to add the user: <strong>" + jqXHR.responseText + "</strong>");
      }
   });
}

function loadYeargroupNamingSchemes(valToSet) {
   if (!valToSet) {
      valToSet = "UK1";
   }

   $.ajax({
      url: "/api/school/yeargroupschemes",
      contentType: false,
      processData: false,
      cache: false,
      type: "GET",
      dataType: "json",
      success: function (data) {
         let select = $("#tab-schoolsettings-yeargroupnaming select");
         select.empty();

         $.each(data.keys, function (k, key) {
            let namingScheme = data.mapping[key];
            let namingSchemeFiltered = [];

            for (let i = 0; i < namingScheme.length; i++) {
               if (namingScheme[i]) namingSchemeFiltered.push(namingScheme[i]);
            }

            let namingStr = limitLength(namingSchemeFiltered.join(", "), 60);
            select.append("<option value='" + key + "'>" + key + "</option>");
         });

         select.val(valToSet);
      },
      error: function (jqXHR, textStatus, errorThrown) {
         dfmAlert("An error occurred trying to add the user: <strong>" + jqXHR.responseText + "</strong>");
      }
   });
}

function lookupStudent(uid) {
   $.ajax({
      url: "/api/user/current/studentclass/" + uid,
      contentType: false,
      processData: false,
      cache: false,
      type: "GET",
      dataType: "json",
      success: function (cl) {
         loadClassData(cl.cid);
         setTimeout(function () {
            $("#classes-student-" + uid + " input[type=checkbox]").click();

            if (currentPageState.action == "move") {
               $("#classes-viewclass-actions").val('1').change();
            }
            if (currentPageState.action == "edit") {
               $("#classes-viewclass-actions").val('0').change();
            }
         }, 1000);
      },
      error: function(jqXHR, textStatus, errorThrown) {
         dfmAlert("An error occurred trying to lookup the class of the user: <strong>"+jqXHR.responseText+"</strong>");
      }
   });
}

function buildPrimaryContactSelect (primaryContactId, teachers = []) {
   const select = $("#tab-schoolsettings-primarycontact select");
   if (select.children().length === 0) {
      select.append(`<option value=0 disabled=${!!primaryContactId}>Please select</option>`);
      teachers.forEach(({ uid, firstname, surname, email }) => {
         select.append(`<option value=${uid}>${firstname} ${surname} (${email})</option>`);
      });
   }
   const isValidId = !!teachers.find(t => t.uid === primaryContactId);
   select.val(isValidId ? primaryContactId : 0);
}

// -----------------------------------
// -- Resizing
// -----------------------------------

$(window).resize(function(){
   var height = $(window).height() - $("#top-bar").outerHeight() - 10;
   var tbodyHeight = $(window).height() - $("#top-bar").outerHeight() - $("#classes-viewclass-header").outerHeight() - $("#classes-viewclass-main-header").outerHeight() - $("#classes-students thead").outerHeight() - $("#teachers-list thead").outerHeight() - 70;
   $("#settings-content > div").outerHeight(height);
   $("#classes-students tbody").outerHeight(tbodyHeight);
   $("#teachers-list tbody").outerHeight(tbodyHeight);

});



// --------------------------------------
// -- Page state management
// --------------------------------------

var currentPageState;

window.onpopstate = function(e){
   if(e.state)loadFromPageState(e.state, true);
};

function loadFromPageState(state, retrievingState) {
   console.log("[RetrievingState] state="+JSON.stringify(state)+" retrieving="+retrievingState);
   currentPageState = state;

   // Ticket 390: Only apply the page state if it's applicable to the user.  Students should not be able to see
   //   teacher-only tabs just by putting the tab ID in the URL
   if (currentPageState.uid && isTeacher()) {
      lookupStudent(currentPageState.uid);
   }
   else if (currentPageState.mode || currentPageState.tab) {
      const requestedTab = currentPageState.mode || currentPageState.tab;

      // We don't have a good data model of which tabs are teacher only; look at the class in the DOM.
      // N.B. the class is on the <li> while the tab ID is on the nested <a>; we assume this hierarchy doesn't change,
      //   but if it does we fail-open (i.e. if we can't definitively find the list element, we allow the user to
      //   navigate to the page.  This should not be an issue as long as we enforce security properly on the backend;
      //   a student won't be able to perform any teacher-exclusive actions.)
      const linkEl = $("li > a[href='#tabs-" + requestedTab + "']");
      const isTeacherOrTrustAdmin = isTeacher() || isTrustAdmin();
      if (linkEl.parent().hasClass("teacheronly") && !isTeacherOrTrustAdmin) {
         return;
      }
      if (linkEl.parent().hasClass("parentonly") && !isParent()) {
         return;
      }

      // Rudimentary permissions checks passed; load the tab
      $("#settings-menu-container").dfmSideMenu("selectTab", "tabs-"+requestedTab);
   }
   else if (currentPageState.cid === "teachers" && isTeacher()) {
      $("#settings-menu-container").dfmSideMenu("selectTab", "tabs-teachers");
   }
   else if(currentPageState.cid && isParent()) {
      $("#settings-menu-container").dfmSideMenu("tabs-children");
   }
   else if(currentPageState.cid && isTeacher()) {
      $("#settings-menu-container").dfmSideMenu("selectTab", "tabs-classes");
      loadClassData(currentPageState.cid, undefined, true)
   }
}



function saveState(title, url) {
   console.log("[SaveState] title="+title+" url="+url+" currentPageState="+JSON.stringify(currentPageState));
   document.title = title;
   window.history.pushState(currentPageState, null, url);
}

// Get data required for subscription panel.
function getSubscriptionPanelData(sid) {
   if (typeof sid === "number") {
      return Promise.all([
         "/api/school",
         "/api/subscription",
         `/api/subscription/intents/list/${sid}`,
         `/api/school/${sid}/subscription/application/pending`
      ].map(async (url) => {
         const response = await fetch(url);
         if (response.ok) {
            return response.json();
         } else {
            const e = await response.json();
            throw new Error(e.message ?? "There was an error getting subscription panel data.");
         }
      }));
   }
}

// Render subscription panel React component
const subscriptionReactRoot = createRoot(document.getElementById("subscriptions-react-root"));
async function renderSubscriptionPanel() {
   if (Context.user?.sid) {
      try {
         const [ school, subscription, invoices, pendingApplication ] = await getSubscriptionPanelData(Context.user.sid);
         const data = { school, subscription, invoices, pendingApplication, user: Context.user }
         subscriptionReactRoot.render(<Subscription data={data} />);
      } catch (e) {
         subscriptionReactRoot.render(
            <div style={{
               backgroundColor: "rgba(139,0,0,0.1)",
               border: "1px darkred solid",
               borderRadius: "4px",
               color: "darkred",
               display: "inline-block",
               fontSize: "14px",
               marginTop: "20px",
               padding: "12px"
            }}>
               There was an error getting your subscription information.
            </div>
         );
      }
   }
}
